<template>
  <category-form :value="category" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="submit" type="submit">Enregistrer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </category-form>
</template>

<script>
  import CategoryForm from './CategoryForm.vue';

  import CategoryCreateMutation from './graphql/CategoryCreateMutation.gql';

  export default {
    components: {
      CategoryForm,
    },
    data() {
      const {search = null} = this.$route.query || {};
      return {
        category: {
          name: search,
          order: 50,
          published: false,
        },
      };
    },
    methods: {
      async save(data) {
        try {
          await this.$apollo.mutate({
            mutation: CategoryCreateMutation,
            variables: {
              data,
            },
          });

          this.$store.dispatch('addNotificationSuccess', `Le métier a été créé !`);
          this.$router.push({name: 'categories'});

        } catch (err) {
          if (err.message.match(/duplicate/)) {
            return this.$store.dispatch('addNotificationError', `L'alias est déjà utilisé par un autre métier !`);
          }
          this.$store.dispatch('addNotificationError', err.message);
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/categories/CategoryCreate.vue